import {Component, OnInit, ViewChild, OnDestroy} from '@angular/core';
import {Router} from '@angular/router';
import {MessageService} from '../message.service';
import {NgbModal ,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {CommonSlickgridComponent} from '../common-slickgrid/common-slickgrid.component';
import {CustomInputEditor} from '../custom-inputEditor';
import {RestApiService} from '../rest-api.service';
import {Formatters} from 'angular-slickgrid';
import {NotifierService} from 'angular-notifier';
import {Subscription} from 'rxjs';
import {FormControl} from '@angular/forms';

@Component({
    selector: 'app-url-creation',
    templateUrl: './url-creation.component.html',
    styleUrls: ['./url-creation.component.css']
})
export class UrlCreationComponent implements OnInit, OnDestroy {
    displayed = true;
    url: string;
    urlKey: string;
    urlDesc: string;
    totalData = 0;
    show: boolean;
    selected: number;
    modules = [];
    moduleSelected: number;
    clients = [];
    clientSelected = 0;
    respObject: any;
    private moduleName: string;

    displayData: any;

    add: boolean;
    del: boolean;
    edit: boolean;
    view: boolean;

    isError = false;
    errorMessage: string;

    private notifier: NotifierService;
    nextOffset: number;
    previousOffset: number;
    pageSize: number;
    paginationType: string;
    page_no: number;
    totalPage: number;
    clientId: number;
    private baseFlag: any;
    private adminAuth: Subscription;
    slideChecked = 'N';
    isHidden: boolean;
    urlKeys = [];
    keySelected: string;
    dataLoaded:boolean;
    showSearch = true;
    isLoading = false;
    searchData: FormControl = new FormControl();
    urlSelected: any;
    urls: any;
    urlName: string;
    showExportBtn = true;
    dataExcel = [];
    isExportDisable = false;

    @ViewChild('scarch_content') private scarch_content;
    private searchModalReference: NgbModalRef;



    constructor(private _rest: RestApiService, private messageService: MessageService, private route: Router,
                private modalService: NgbModal, notifier: NotifierService) {
        this.notifier = notifier;
        this.messageService.getCellChangeData().subscribe(item => {
            switch (item.type) {
                case 'change':
                    console.log('changed');
                    if (!this.edit) {
                        this.notifier.notify('error', 'You do not have edit permission');
                    } else {
                        if (confirm('Are you sure?')) {
                            const data = {
                                url: item.url,
                                urlDesc: item.urlDesc,
                                createdBy: this.messageService.getUserId(),
                                urlKey: item.urlKey,
                                id: item.id
                            };
                            this._rest.editUrlMst(data).subscribe((res) => {
                                this.respObject = res;
                                if (this.respObject.success) {
                                    this.notifier.notify('success', this.messageService.EDIT_SUCCESS);
                                } else {
                                    console.log('data--Not---Done');
                                }
                            }, (err) => {
                            });
                        }
                    }
                    break;
                case 'delete':
                    console.log('deleted');
                    if (!this.del) {
                        this.notifier.notify('error', 'You do not have delete permission');
                    } else {
                        if (confirm('Are you sure?')) {
                            this._rest.deleteUrl({id: item.id, user_id: this.messageService.getUserId()}).subscribe((res) => {
                                this.respObject = res;
                                if (this.respObject.success) {
                                    this.messageService.sendAfterDelete(item.id);
                                } else {
                                    this.notifier.notify('error', this.respObject.errorMessage);
                                }
                            }, (err) => {
                                this.notifier.notify('error', this.respObject.errorMessage);
                            });
                        }
                    }
                    break;
            }
        });
        this.messageService.getUserAuth().subscribe(details => {
            // console.log(JSON.stringify(details));
            if (details.length > 0) {
                this.add = details[0].addFlag;
                this.del = details[0].deleteFlag;
                this.view = details[0].viewFlag;
                this.edit = details[0].editFlag;
            } else {
                this.add = false;
                this.del = false;
                this.view = false;
                this.edit = false;
            }
        });
        this.messageService.getSelectedItemData().subscribe(selectedTitles => {
            if (selectedTitles.length > 0) {
                this.show = true;
                this.selected = selectedTitles.length;
            } else {
                this.show = false;
            }
        });
    }

    ngOnInit() {
        this.dataLoaded = false;
        this.nextOffset = 0;
        this.previousOffset = 0;
        this.pageSize = this.messageService.pageSize;
        this.page_no = 0;
        this.totalPage = 0;
        this.paginationType = 'next';
        this.displayData = {
            pageName: ' Maintain Url Creation',
            openModalButton: 'Create Url',
            searchModalButton: 'Search',
            breadcrumb: 'UrlCreation',
            folderName: 'All Urls',
            tabName: 'Urls',
            exportBtn: 'Export to excel'

        };

        const columnDefinitions = [{
            id: 'delete',
            field: 'id',
            excludeFromHeaderMenu: true,
            formatter: Formatters.deleteIcon,
            minWidth: 30,
            maxWidth: 30,
        },
            // {id: 'id', name: 'Id', field: 'id', sortable: true, filterable: true},
            {
                id: 'url', name: 'Url', field: 'url', sortable: true, filterable: true, cssClass: 'highlight',editor: {
                    model: CustomInputEditor,
                }
            },
            {
                id: 'urlKey', name: 'Url Key', field: 'urlKey', sortable: true, filterable: true,cssClass: 'highlight', editor: {
                    model: CustomInputEditor,
                }
            },
            {
                id: 'urlDesc', name: 'Url Description', field: 'urlDesc', sortable: true, filterable: true,cssClass: 'highlight', editor: {
                    model: CustomInputEditor,
                }
            },
            {
                id: 'module', name: 'Mapped Module', field: 'moduleName', sortable: true, filterable: true
            }
        ];
        this.messageService.setColumnDefinitions(columnDefinitions);
        this._rest.getModules().subscribe((res) => {
            this.respObject = res;
            if (this.respObject.success) {
                this.respObject.modules.unshift({id: 0, MODULENAME: 'Select Module'});
                this.modules = this.respObject.modules;
                this.moduleSelected = 0;
            } else {

            }
        }, function (err) {

        });
        this.moduleSelected = 0;
        if (this.messageService.clientId) {
            this.clientId = this.messageService.clientId;
            this.baseFlag = this.messageService.baseFlag;
            this.onPageLoad();
        } else {
            this.adminAuth = this.messageService.getUserAuth().subscribe(details => {
                if (details.length > 0) {
                    this.add = details[0].addFlag;
                    this.del = details[0].deleteFlag;
                    this.view = details[0].viewFlag;
                    this.edit = details[0].editFlag;
                    this.clientId = details[0].clientId;
                    this.baseFlag = details[0].baseFlag;
                    this.onPageLoad();
                }
            });
        }
        this.searchData.valueChanges.subscribe(
            name => {
                if (name.length > 2) {
                    this.isLoading = true;
                    this._rest.searchAllModulePageUrlMapping( name, this.clientId).subscribe((res1) => {
                        this.respObject = res1;
                        this.isLoading = false;
                        if (this.respObject.success) {
                            this.urls = this.respObject.details;
                        } else {
                            this.notifier.notify('error', this.respObject.errorMessage);
                        }
                    }, (err) => {
                        this.isLoading = false;
                        this.notifier.notify('error', this.messageService.SERVER_ERROR);
                    });
                } else {
                    this.urls = [];
                }
            });
    }

    onPageLoad() {
        this.getTableData();
    }


    exportToExcel() {
        this.isExportDisable = true;

        // console.log("okkk" +this.clientId);
        this._rest.getAllModulePageUrl(this.clientId).subscribe((res1) => {
            this.respObject = res1;
            if (this.respObject.success) {
                this.isExportDisable = false;

                this.dataExcel = this.respObject.details;
                // console.log('true' + JSON.stringify(this.dataExcel));
                this.messageService.exportAsExcelFile(this.dataExcel);
            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });
    }


    openModal(content) {
        if (!this.add) {
            this.notifier.notify('error', 'You do not have add permission');
        } else {
            this.isError = false;
            this.url = '';
            this.urlDesc = '';
            this.moduleSelected = 0;
            this.urlKey = '';
            this.slideChecked = 'N';
            this.keySelected = 'Select an Existing Key';
            this.modalService.open(content, {size: 'sm'}).result.then((result) => {
            }, (reason) => {

            });
        }
    }
    searchModal() {
        if (!this.add) {
            this.notifier.notify('error', 'You do not have add permission');
        } else {
            this.isError = false;
            this.url = '';
            this.urlDesc = '';
            this.moduleSelected = 0;
            this.urlKey = '';
            this.slideChecked = 'N';
            this.keySelected = 'Select an Existing Key';
            this.urlName = '';
            this.urlSelected = '';
            this.searchModalReference = this.modalService.open(this.scarch_content);
            this.searchModalReference.result.then((result) => {
            }, (reason) => {

            });
        }
    }

    getDetails() {
        for (let i = 0; i < this.urls.length; i++) {
            if (this.urls[i].urlKey === this.urlSelected) {
                this.urlName = this.urls[i].url;
            }
        }
    }
    search() {
      const data1 = [];
      for (let i = 0; i < this.urls.length; i++) {
          if (this.urls[i].urlKey === this.urlSelected) {
            data1.push(this.urls[i]);
          }
      }
      this.page_no = 1;
      this.messageService.setTotalData(data1.length);
      this.messageService.setGridData(data1);
      this.searchModalReference.close();

    }

    changeRouting(path: string) {
        this.messageService.changeRouting(path);
    }

    onButtonChange(selectedButton) {
        this.slideChecked = selectedButton.value;
        if (this.slideChecked === 'N') {
            this.isHidden = false;
        } else {
            this.isHidden = true;
            if (this.urlKeys.length === 0) {
                this._rest.getDistinctUrlKey(this.moduleSelected, this.messageService.getUserId(), this.clientId).subscribe((res) => {
                    this.respObject = res;
                    if (this.respObject.success) {
                        this.respObject.details.unshift({URLKEY: 'Select an Existing Key'});
                        this.urlKeys = this.respObject.details;
                        this.keySelected = this.urlKeys[0].URLKEY;
                    } else {

                    }
                }, (err) => {
                    // console.log(err);
                });
            } else {
                this.keySelected = 'Select an Existing Key';
            }
        }
    }

    save() {
        // if (this.slideChecked === 'E') {
        //     this.urlKey = this.keySelected;
        // }
        // if (this.urlKey === 'Select an Existing Key') {
        //     this.isError = true;
        //     this.errorMessage = this.messageService.BLANK_ERROR_MESSAGE;
        // } else {
            const data = {
                clientId: '1', url: this.url, urlDesc: this.urlDesc, moduleId: this.moduleSelected, urlKey: this.urlKey
            };
            console.log(JSON.stringify(data));
            if (!this.messageService.isBlankField(data)) {
                this._rest.addUrl(data).subscribe((res) => {
                    this.respObject = res;
                    if (this.respObject.success) {
                        this.isError = false;
                        const id = this.respObject.details;
                        this.nextOffset = 0;
                        this.page_no = 0;
                        this.getTableData();
                        // this.messageService.setRow({id: id, url: this.url, urlDesc: this.urlDesc, moduleName: this.moduleName, urlKey: this.urlKey});
                        this.urlDesc = '';
                        this.urlKey = '';
                        this.url = '';
                        this.moduleSelected = 0;
                    } else {
                        this.isError = true;
                        this.errorMessage = this.respObject.errorMessage;
                    }
                }, (err) => {
                    this.isError = true;
                    this.errorMessage = err;
                });
            // } else {
            //     this.isError = true;
            //     this.errorMessage = this.messageService.BLANK_ERROR_MESSAGE;
            // }
        }
    }

    getTableData() {
        if (!this.view) {
            this.notifier.notify('error', 'You do not have view permission');
        } else {
            this.getData({'offset': this.nextOffset, 'paginationType': ''});
        }
    }

    isEmpty(obj) {
        for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
                return false;
            }
        }
        return true;
    }

    getData(paginationObj) {
        const offset = paginationObj.offset;
        const paginationType = paginationObj.paginationType;
        this.dataLoaded=false;
        this._rest.getUrlByClient(this.clientId, offset, this.pageSize, paginationType).subscribe((res) => {
            this.respObject = res;
            this.executeResponse(this.respObject, offset, paginationType);
        }, (err) => {
            // console.log(err);
        });
    }

    executeResponse(respObject, offset, paginationType) {
        if (respObject.success) {
            this.dataLoaded=true;
            if (offset === 0) {
                this.totalData = respObject.details.totalData[0].count;
                this.totalPage = respObject.details.totalPage;
                if (this.totalPage === 0) {
                    this.totalPage = 1;
                }
            }
            if (!this.isEmpty(respObject.details.dataObj)) {
                const data = respObject.details.dataObj;
                this.nextOffset = respObject.details.nextOffset;
                this.previousOffset = respObject.details.previousOffset;
                this.messageService.setTotalData(this.totalData);
                this.messageService.setGridData(data);
                // ----------------------------------------------
                if (offset !== 0) {
                    const totalCount = this.totalData;
                    const divRes = totalCount / this.pageSize;
                    const remainder = totalCount % this.pageSize;
                    if (remainder === 0) {
                        this.totalPage = parseInt(String(divRes), 10);
                    } else {
                        this.totalPage = parseInt(String(divRes), 10) + 1;
                    }
                }
                // ------------------------------------------------
                if (paginationType === 'next') {
                    this.page_no = this.page_no + 1;
                } else if (paginationType === 'prev') {
                    this.page_no = this.page_no - 1;
                } else if (paginationType === '' && this.page_no === 0) {
                    this.page_no = this.page_no + 1;
                }
                if (this.totalData <= this.pageSize * this.page_no) {
                    this.nextOffset = 0;
                }
            } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'next') {
                this.nextOffset = 0;
            } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'prev') {
                this.previousOffset = 0;
            } else if (paginationType === '' && this.page_no === 0) {
                this.page_no = this.page_no + 1;
            }
        } else {
            this.notifier.notify('error', respObject.errorMessage);
        }
    }

    onPageSizeChange(value: any) {
        this.page_no = 0;
        this.nextOffset = 0;
        this.pageSize = value;
        this.getData({'offset': this.nextOffset, 'paginationType': ''});
    }

    onModuleChange(value: any) {
        this.moduleName = this.modules[value].MODULENAME;
    }

    ngOnDestroy(): void {
        if (this.adminAuth) {
            this.adminAuth.unsubscribe();
        }
    }
}
